import { AuthProvider, HttpError } from "@pankod/refine-core";
import { config } from "../config";
import axios from "axios";
import jwt_decode from "jwt-decode";
import posthog from "./posthog";

export const axiosInstance = axios.create();
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const customError: HttpError = {
      ...error,
      description: "asdsa",
      message: error.response?.data?.message,
      statusCode: error.response?.status,
    };

    return Promise.reject(customError);
  },
);

export const authProviderRest: AuthProvider = {
  login: () => Promise.resolve(),
  logout: async () => {
    const tokensRaw = localStorage.getItem(config.TOKEN_KEY);
    const tokens = tokensRaw ? JSON.parse(tokensRaw) : undefined;
    const res = await axios.get(`${config.API_URL}/auth/logout`, {
      headers: {
        Authorization: `Bearer ${tokens.accessToken}`,
      },
    });
    if (res.status === 200) {
      localStorage.removeItem(config.TOKEN_KEY);
      localStorage.removeItem(config.USER_KEY);
      posthog.reset();
    }

    return Promise.resolve();
  },
  checkError: (error) => {
    const status = error.status;
    if (status === 403) {
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: async () => {
    const tokensRaw = localStorage.getItem(config.TOKEN_KEY);
    const tokens = tokensRaw ? JSON.parse(tokensRaw) : undefined;
    let access_token = tokens?.accessToken;
    if (access_token && tokens) {
      const decoded = jwt_decode(access_token) as any;
      const now = new Date().getTime();
      const expTime = decoded.exp * 1000;
      const isExpired = now - expTime > 0;
      if (isExpired) {
        try {
          const res = await axios.get(`${config.API_URL}/auth/refresh`, {
            headers: {
              Authorization: `Bearer ${tokens.refreshToken}`,
            },
          });
          const { tokens: _tokens, user: _user } = res.data;
          if (res.data) {
            access_token = _tokens.accessToken;
            _tokens && localStorage.setItem(config.TOKEN_KEY, JSON.stringify(_tokens));
            _user && localStorage.setItem(config.USER_KEY, JSON.stringify(_user));
          }
        } catch (error) {
          // Refresh token is also expired or invalid — clear storage and save current URL for post-login redirect
          localStorage.removeItem(config.TOKEN_KEY);
          localStorage.removeItem(config.USER_KEY);
          const currentPath = window.location.pathname + window.location.search + window.location.hash;
          const isOAuthCallback = /^\/auth\/[^/]+\/callback/.test(
            window.location.pathname,
          );
          if (
            currentPath &&
            currentPath !== "/" &&
            currentPath !== "/login" &&
            !isOAuthCallback
          ) {
            localStorage.setItem("redirectPath", currentPath);
          }
          return Promise.reject();
        }
      }
      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
      return Promise.resolve();
    }

    // No tokens at all — save current URL for post-login redirect
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    const isOAuthCallback = /^\/auth\/[^/]+\/callback/.test(
      window.location.pathname,
    );
    if (
      currentPath &&
      currentPath !== "/" &&
      currentPath !== "/login" &&
      !isOAuthCallback
    ) {
      localStorage.setItem("redirectPath", currentPath);
    }
    return Promise.reject();
  },
  getPermissions: () => Promise.resolve(),
  getUserIdentity: async () => {
    return Promise.reject();
  },
};
